/* eslint-disable key-spacing */
import { hsl } from '../../../utils/svgs'

export default {
    fill: {
        dotsBottom: hsl(0, 0, 42),
        dotsFace:   hsl(0, 0, 52),
        cBottom:    hsl(5, 43, 42),
        cFace:      hsl(5, 43, 52),
        gBottom:    hsl(25, 48, 37),
        gFace:      hsl(25, 48, 47),
        dBottom:    hsl(48, 48, 32),
        dFace:      hsl(48, 48, 42),
        aBottom:    hsl(60, 48, 32),
        aFace:      hsl(60, 48, 42),
        eBottom:    hsl(100, 48, 32),
        eFace:      hsl(100, 48, 42),
        bBottom:    hsl(150, 48, 32),
        bFace:      hsl(150, 48, 42),
        fgBottom:   hsl(180, 48, 32),
        fgFace:     hsl(180, 48, 42),
        cdBottom:   hsl(205, 38, 42),
        cdFace:     hsl(205, 38, 52),
        gaBottom:   hsl(230, 38, 52),
        gaFace:     hsl(230, 38, 62),
        deBottom:   hsl(260, 38, 47),
        deFace:     hsl(260, 38, 57),
        abBottom:   hsl(290, 33, 42),
        abFace:     hsl(290, 33, 52),
        fBottom:    hsl(335, 33, 42),
        fFace:      hsl(335, 33, 52),
    },
}
